import react from 'react';
import bottle from '../assets/transparent_A2.png';
import { useRef } from 'react';

function Hero({ footerRef }) {
    const scrolltosection = (ref) => {
        if (!ref || !ref.current) return;
        ref.current.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <div
            dir='rtl'
            className='px-4 py-0 min-h-screen font-ibmArabic selection:bg-[var(--primary)] selection:text-[var(--header)] flex justify-center items-center' 
            style={{
                background: "linear-gradient(135deg, #F0FFFF 0%, #E0F7FF 35%, #B3E9FF 70%, #7FD4FF 100%)", 
                margin: '0px',
            }}
        >
            <div className="flex flex-row-reverse items-center justify-center gap-0 max-w-7xl mx-auto w-full"> 
                
                <div className="flex justify-end items-center"> 
                    <img
                        decoding='async'
                        src={bottle}
                        alt='bottle'
                        className='max-w-[180px] sm:max-w-[150px] md:max-w-[210px] lg:max-w-[250px] animate-slideInLeft'
                    />
                </div>

                <div className="flex flex-col text-right items-start justify-start pt-5 w-[800px]"> 
                    <h1 className='text-[var(--primary)] font-bold text-2xl md:text-4xl lg:text-6xl mb-5 text-right lg:font-extrabold font-ibmArabic '> 
                        مياه مارة
                    </h1>
                    <h3 className='text-[grey] text-xl sm:text-2xl md:text-2xl lg:text-3xl font-bold font-ibmArabic text-right'> 
                            لأننا نريد صحتك اخترنا لك مارة.
                        <br/>
                        مياه معالجة بأحدث طرق معالجة المياه في العالم
                    </h3>
                    <button
                        onClick={() => scrolltosection(footerRef)}
                        className="mt-6 px-8 py-3 bg-[var(--primary)] text-white text-lg font-bold rounded-full hover:bg-[var(--primary-dark)] transition-all duration-300 shadow-md hover:scale-105"
                    >
                        تواصل معنا
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Hero;